// 一般配置信息放在meta上，比如使用isrm的哪个数据中心ibosDataCenter
export default () => {
  const baseData = document.querySelector('meta[name="base.data"]')?.content;
  console.log('----baseData--1', baseData)
  return (baseData && JSON.parse(baseData)) || {};
};